import { useState, useCallback } from 'react'

export const useSwitcher = (initialIndex = 0) => {
  const [index, setIndex] = useState(initialIndex)

  return {
    index,
    updateIndex: useCallback(newIndex => setIndex(newIndex), []),
  }
}
